// extracted by mini-css-extract-plugin
export default {"availablityCalendar":"CustomRangeInput_availablityCalendar__gbeAP","checkboxes":"CustomRangeInput_checkboxes__eEJKc","priceText":"CustomRangeInput_priceText__xbzWn"};